import type { ReactNode } from 'react'

import React from 'react'
import AppLoader from '@components/common/AppLoader'

/**
 * Рендерит меню пикера с лоадером пока данные загружаются
 */
export const renderLazyPickerMenu = (loading: boolean, data?: object) => (menu: ReactNode) => {
  if (loading || !data) {
    return (
      <div>
        <AppLoader.Inline content="Загружаем" />
      </div>
    )
  }

  return menu
}
